import { useLocation } from 'react-router-dom'

const SITE_ORIGIN = 'https://geoborder.us'
const DEFAULT_OG_IMAGE = 'https://geoborder.us/og-card.png'

type SeoHeadProps = {
  title: string
  description: string
  /** Override the canonical path. Defaults to the current location pathname. */
  canonicalPath?: string
  /** Set true on authenticated / sensitive pages. Backstops robots.txt. */
  noindex?: boolean
}

// Per-page meta. React 19 hoists <title>, <meta>, and <link> from any
// component into <head> automatically — no helmet library needed.
// Source: https://react.dev/reference/react-dom/components/title
export function SeoHead({ title, description, canonicalPath, noindex }: SeoHeadProps) {
  const { pathname } = useLocation()
  const canonical = `${SITE_ORIGIN}${canonicalPath ?? pathname}`

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large" />
      )}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={DEFAULT_OG_IMAGE} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
    </>
  )
}
